import { useState } from "react";
import { api } from "../../../../../utility/api";

const ENDPOINT = "correlativo_tancadas";

// Correlativo con el que se numeran las tancadas: se configura al empezar a
// usar el sistema y se reinicia al terminar cada período de producción
export const CorrelativoTancadasApi = () => {
    const [cargando, setCargando] = useState(false);

    const getEstadoCorrelativo = async () => {
        try {
            setCargando(true);
            const response = await api.get(`${ENDPOINT}/estado`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    // la configuración inicial y el reinicio abren un período, así que usan el
    // mismo endpoint; en el reinicio no se manda correlativo
    const abrirPeriodo = async (data) => {
        try {
            setCargando(true);
            const response = await api.post(`${ENDPOINT}/abrir_periodo`, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const deshacerPeriodo = async () => {
        try {
            setCargando(true);
            const response = await api.eliminar(`${ENDPOINT}/deshacer_periodo`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getEstadoCorrelativo,
        abrirPeriodo,
        deshacerPeriodo,

        cargando,
    };
};
